export default __webpack_public_path__ + "static/media/matrix.c115a769.svg";